import React from 'react'
import { CommentAnchorType } from '@marketing-milk/interfaces'
import { radius, SurfacePalette, type } from '../tokens'
import { CommentIndicator } from './CommentIndicator'

interface Props {
  palette: SurfacePalette
  label: string
  value: string
  sublabel?: string
  commentAnchor?: { type: CommentAnchorType; id: string; label?: string }
}

export const KPITile = ({ palette, label, value, sublabel, commentAnchor }: Props) => (
  <div
    className="group"
    data-comment-anchor-type={commentAnchor?.type}
    data-comment-anchor-id={commentAnchor?.id}
    data-comment-label={commentAnchor?.label ?? label}
    style={{
      position: 'relative',
      padding: 20,
      borderRadius: radius.md,
      border: `1px solid ${palette.hairline}`,
      background: palette.surface,
      fontFamily: type.family.sans,
    }}
  >
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 8,
      }}
    >
      <div
        style={{
          fontFamily: type.family.mono,
          fontSize: type.size.eyebrow,
          fontWeight: type.weight.regular,
          color: palette.textFaint,
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
        }}
      >
        {label}
      </div>
      {commentAnchor && <CommentIndicator palette={palette} label={label} hideUntilGroupHover />}
    </div>
    <div
      style={{
        marginTop: 10,
        fontFamily: type.family.sans,
        fontSize: type.size.h2,
        fontWeight: type.weight.semibold,
        color: palette.text,
        lineHeight: 1.1,
      }}
    >
      {value}
    </div>
    {sublabel && (
      <div
        style={{
          marginTop: 4,
          fontFamily: type.family.sans,
          fontSize: type.size.eyebrow,
          color: palette.textFaint,
        }}
      >
        {sublabel}
      </div>
    )}
  </div>
)
